import { render, staticRenderFns } from "./FormUserHotAlertConfig.vue?vue&type=template&id=5b38a87a&"
import script from "./FormUserHotAlertConfig.vue?vue&type=script&lang=js&"
export * from "./FormUserHotAlertConfig.vue?vue&type=script&lang=js&"
import style0 from "./FormUserHotAlertConfig.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports